export default {
    unreadCount: (state) => {
        return state.notifications.filter(n => !n.read_at).length
    },
}
